export const limitErrors = 50;
